import React from "react";

import { ReactComponent as DroughtSvg } from "assets/perils/climate/drought_score.svg";
import { ReactComponent as WindSvg } from "assets/perils/climate/wind.svg";
import { ReactComponent as Flood1daySvg } from "assets/perils/climate/fluvial_flood_risk_change_1day_extreme.svg";
import { ReactComponent as Flood3daySvg } from "assets/perils/climate/fluvial_flood_risk_change_3day_extreme.svg";
import { ReactComponent as HeatWaveSvg } from "assets/perils/climate/heat_wave_score.svg";
import { ReactComponent as PrecipWinterSvg } from "assets/perils/climate/precipitation_change.svg";
import { ReactComponent as PrecipSummerSvg } from "assets/perils/climate/precipitation_change_jun_jul_aug.svg";
import { ReactComponent as SealevelRiseSvg } from "assets/perils/climate/sea_level_rise.svg";
import { ReactComponent as FloodFathomSvg } from "assets/perils/hazard/fl_fluvial_global_fathom.svg";
import { ReactComponent as PluvialFathomSvg } from "assets/perils/hazard/fl_pluvial_global_fathom.svg";
import { ReactComponent as CoastalFathomSvg } from "assets/perils/hazard/fl_coastal_global_fathom.svg";
import { ReactComponent as BushSvg } from "assets/perils/hazard/distance_to_bush.svg";
import { ReactComponent as EarthQuakeBedrockSvg } from "assets/perils/hazard/earthquake_bedrock_conditions.svg";
import { ReactComponent as EarthQkSoilSvg } from "assets/perils/hazard/earthquake_soil_conditions.svg";
import { ReactComponent as FloodSvg } from "assets/perils/hazard/fluvial_flood.svg";
import { ReactComponent as FloodSRSvg } from "assets/perils/hazard/fluvial_flood_sr.svg";
import { ReactComponent as SubsidenceSvg } from "assets/perils/hazard/france_subsidence.svg";
import { ReactComponent as HailstormSvg } from "assets/perils/hazard/hailstorm.svg";
import { ReactComponent as LandslideSvg } from "assets/perils/hazard/landslide.svg";
import { ReactComponent as LightningSvg } from "assets/perils/hazard/lightning.svg";
import { ReactComponent as PluvialFloodSvg } from "assets/perils/hazard/pluvial_flood_sr.svg";
import { ReactComponent as StormSvg } from "assets/perils/hazard/storm_surge.svg";
import { ReactComponent as TornadoSvg } from "assets/perils/hazard/tornado.svg";
import { ReactComponent as TsunamiSvg } from "assets/perils/hazard/tsunami.svg";
import { ReactComponent as VolcanoSvg } from "assets/perils/hazard/volcano_ash_thickness.svg";
import { ReactComponent as WildfireSvg } from "assets/perils/hazard/wildfire.svg";
import { ReactComponent as WindstormSvg } from "assets/perils/hazard/windstorm.svg";
import { ReactComponent as EarthquakeSvg } from "assets/perils/event/earthquake.svg";
import { ReactComponent as RainfallSvg } from "assets/perils/event/rainfall.svg";
import { ReactComponent as CycloneSvg } from "assets/perils/event/cyclone.svg";
import { ReactComponent as HeatStressSvg } from "assets/perils/climate/heat_stress.svg";
import { ReactComponent as PrecipExtreme3Day99thSvg } from "assets/perils/climate/precip_extreme_3_day_99th.svg";
import { ReactComponent as PrecipAnnualAccumulatedSvg } from "assets/perils/climate/precip_annual_accumulated.svg";
import { ReactComponent as HeatStressDaysTwbgAbove32cSvg } from "assets/perils/climate/heat_stress_days_twbg_above_32c.svg";
import { ReactComponent as WildfireDaysFwiAbove213Svg } from "assets/perils/climate/wildfire_days_fwi_above_21_3.svg";
import style from "./svg.module.scss";

const iconDict: { [key: string]: React.FunctionComponent<any> } = {
	FL_Fluvial_Official: FloodSvg,
	FL_Fluvial_SwissRe: FloodSRSvg,
	FL_Pluvial_SwissRe: PluvialFloodSvg,
	FL_Fluvial_Global_Fathom: FloodFathomSvg,
	FL_Pluvial_Global_Fathom: PluvialFathomSvg,
	FL_Coastal_Global_Fathom: CoastalFathomSvg,
	FL_Surge_SwissRe: StormSvg,
	EQ_Bedrock_Global_SwissRe: EarthQuakeBedrockSvg,
	EQ_Tsunami_SwissRe: TsunamiSvg,
	EQ_LocalSoilCondition_Global_SwissRe: EarthQkSoilSvg,
	WS_Windspeed_Global_SwissRe: WindstormSvg,
	CS_Hail_Global_SwissRe: HailstormSvg,
	CS_Tornado_Global_SwissRe: TornadoSvg,
	EQ_Landslide_Global_SwissRe: LandslideSvg,
	CS_Lightning_Global_SwissRe: LightningSvg,
	VO_AshThickness_Global_SwissRe: VolcanoSvg,
	WF_Wildfire_Global_SwissRe: WildfireSvg,
	WF_DistToBush_AUS_SwissRe: BushSvg,
	DR_Subsidence_France_SwissRe: SubsidenceSvg,
	GEO_DistToCoast_Global_SwissRe: BushSvg,
	drought: DroughtSvg,
	drought_old: DroughtSvg,
	wind: WindSvg,
	wet: Flood1daySvg,
	extreme_precipitation: Flood1daySvg,
	boreal_winter_wet: PrecipWinterSvg,
	// extreme_precip_fluvial_flood: PrecipWinterSvg,
	extreme_precip_fluvial_flood: FloodSRSvg,
	boreal_summer_wet: PrecipSummerSvg,
	// extreme_precip_pluvial_flood: PrecipSummerSvg,
	extreme_precip_pluvial_flood: PluvialFloodSvg,
	heat_wave: HeatWaveSvg,
	sea_level_rise: SealevelRiseSvg,
	FloodSRSvg: FloodSRSvg,
	VolcanoSvg: VolcanoSvg,
	earthquake: EarthquakeSvg,
	Earthquake: EarthquakeSvg,
	rainfall: RainfallSvg,
	Rainfall: RainfallSvg,
	cyclone: CycloneSvg,
	Cyclone: CycloneSvg,
	fool: FloodSvg,
	Fool: FloodSvg,
	Flood: FloodSvg,
	winterstorm: CycloneSvg,
	Winterstorm: CycloneSvg,
	wildfire: WildfireSvg,
	wild_fire: WildfireSvg,
	heat_stress: HeatStressSvg,
	fluvial_flood: FloodSRSvg,
	pluvial_flood: PluvialFloodSvg,
	windstorm: WindSvg,
	windstrom: WindSvg,
	storm_surge: SealevelRiseSvg,
	temp_mean_annual: HeatStressSvg,
	temp_extreme_24h: HeatWaveSvg,
	drought_annual_spei_min: DroughtSvg,
	wind_extreme_99th_percentile: WindSvg,
	precip_extreme_3_day_99th: PrecipExtreme3Day99thSvg,
	precip_annual_accumulated: PrecipAnnualAccumulatedSvg,
	heat_stress_days_twbg_above_32c: HeatStressDaysTwbgAbove32cSvg,
	wildfire_days_fwi_above_21_3: WildfireDaysFwiAbove213Svg
};

interface Props {
	icon: string;
	disabled?: boolean;
	style?: any
}

export default function Svg(props: Props) {
	const Icon = iconDict[props.icon];
	return () => <Icon className={props.disabled ? style.disabled : style.icon} style={props.style} />;
}
